import { Component, OnInit, OnDestroy } from '@angular/core';
import { FilterService } from '../_services/filter.service';
import { DocumentsService } from '../_services/documents.service';
import { Filter, FiltersConfig } from '../_models/filter';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit, OnDestroy {
  filters$: Observable<Filter[]>;
  screenFilters$: Observable<any>;
  filtersConfig$: Observable<FiltersConfig>;
  filterReq$: Subscription;

  constructor(
    private router: Router,
    private filterService: FilterService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private documentsService: DocumentsService) {
  }

  ngOnInit(): void {
    this.filters$ = this.filterService.filters$;
    this.screenFilters$ = this.filterService.screenFilters$;
    this.filtersConfig$ = this.filterService.filtersConfig$;
  }

  ngOnDestroy() {
    if (this.filterReq$)
      this.filterReq$.unsubscribe();
  }

  searchWithFilters(filters: FiltersConfig) {    
    this.filterService.storeFiltersConfig(filters);
    const requestConfig = this.filterService.getFiltersRequest();
    this.documentsService.getDocuments(requestConfig).subscribe(data => {
      if (data && data.length > 0) {
        (data.some(document=>document.ExceededLimit))
        ? this.toastr.info(this.translateService.instant('search.document_limit.description'), this.translateService.instant('search.document_limit.title'))
        : this.router.navigateByUrl('/searchresults')
        } else {
          this.toastr.info(this.translateService.instant('search.empty_results.description'), this.translateService.instant('search.empty_results.title'));
      }
    }, err => {
      this.toastr.error(err, this.translateService.instant('error.title'));
    });
  }


}
